<div id="webshop" class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <nav mat-tab-nav-bar class="ya-tab-nav-bar">
      <a mat-tab-link *ngFor="let paymentStep of paymentNavigations" [active]="activeLink === paymentStep" disabled
        [@shake]="states['state'+ paymentStep]"
        (click)="(activeLink !== paymentStep) && ShakeLabel('state'+ activeLink)">
        <span [langkey]="paymentStep"></span>
      </a>
    </nav>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <mat-tab-group [(selectedIndex)]="matGroupSelectedIndex" animationDuration="20ms">
      <mat-tab label="First">
        <ya-inhouse-payment-order #inhousePaymentOrder (onContinue)="onContinue_order()"></ya-inhouse-payment-order>
      </mat-tab>
      <ng-container *ngIf="getCustomerData">
        <mat-tab label="Second">
          <ya-customerData #customerData class="ya-tab-content-wrapper second"
            (onContinue)="onContinue_customerData()"></ya-customerData>
        </mat-tab>
      </ng-container>
      <mat-tab label="Third">
        <div class="ya-tab-content-wrapper second">
          <ya-checkout #checkout></ya-checkout>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>